module.exports = __webpack_public_path__ + "img/betguide-1.c211a2f2.svg";